var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 36,
    viewBox: "0 0 22 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.732258 16.601L16.7538 0.579525C17.5265 -0.193176 18.7792 -0.193176 19.5518 0.579525L21.4205 2.44817C22.1919 3.21955 22.1934 4.46974 21.4238 5.24294L8.72645 18L21.4238 30.7571C22.1934 31.5303 22.1919 32.7804 21.4205 33.5518L19.5518 35.4205C18.7791 36.1932 17.5264 36.1932 16.7538 35.4205L0.732342 19.399C-0.0403591 18.6264 -0.0403592 17.3737 0.732258 16.601Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9eea55ed79d39ebcb019ca3fd58d8e0d.svg";
export { ForwardRef as ReactComponent };